export default {
  name: 'features',

  ui: {
    'items[]': '[js-features-value]',
    'tabs[]': '[js-features-version-tab]',
    version: '[js-features-version]',
    versionDetails: '[js-features-version-details]',
    switch: '[js-features-switch]',
  },

  events: [
    {
      on: 'change',
      target: 'switch',
      handle ({ target }) {
        this.ui.items.forEach((item) => {
          item.classList.toggle('is-hidden')
        })
      },
    },
    {
      on: 'click',
      target: 'tabs',
      handle ({ target }) {
        this.ui.version.innerHTML = target.dataset.version
        this.ui.versionDetails.innerHTML = target.dataset.versionDetails
      },
    },
  ],
}
